//React
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

//mui
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";

// 3rd party
import { getStorage, ref, getDownloadURL } from "firebase/storage";

// project
import { useAuth } from "providers/Auth";

const PROFILE_PICTURE_PATH = "profilePicture";

// The avatar mounts on every page navigation; cache download-url lookups per
// storage path so a picture (or its known absence) is only fetched once per
// page load. Uploading a new picture triggers window.location.reload()
// (AccountInfo), which clears this cache.
const downloadUrlCache = new Map();

const getCachedDownloadUrl = (storage, path) => {
  if (!downloadUrlCache.has(path)) {
    downloadUrlCache.set(
      path,
      getDownloadURL(ref(storage, path)).catch((error) => {
        if (error?.code !== "storage/object-not-found") {
          // Transient failure — drop the entry so the next mount retries.
          downloadUrlCache.delete(path);
          console.error("Error getting image url", error);
        }
        // No profile picture uploaded is a normal state — stay on the default avatar.
        return null;
      })
    );
  }
  return downloadUrlCache.get(path);
};

const SigilAvatar = ({ ...props }) => {
  const [imageUrl, setImageUrl] = useState();
  const storage = getStorage();
  const { auth } = useAuth();
  const { uid, tenant } = auth;

  useEffect(() => {
    let active = true;
    const getImgUrl = async () => {
      const imgUrl = await getCachedDownloadUrl(
        storage,
        `${tenant}/${PROFILE_PICTURE_PATH}/${uid}`
      );
      if (active && imgUrl) setImageUrl(imgUrl);
    };

    getImgUrl();
    return () => {
      active = false;
    };
  }, [setImageUrl, storage, uid, tenant]);

  return (
    <IconButton id="avatar-button" {...props}>
      <Avatar src={imageUrl}></Avatar>
    </IconButton>
  );
};

SigilAvatar.propTypes = {
  props: PropTypes.object,
};

export default SigilAvatar;
export { PROFILE_PICTURE_PATH };
